export function convertWishlistProduct(wkProduct) {
  return {
    ...wkProduct,
    compare_at_price: Math.round(wkProduct.variants[0].compare_at_price * 100),
    price: wkProduct.variants[0].price * 100,
    variants: wkProduct.variants.map((variant) => ({
      ...variant,
      price: variant.price * 100,
      compare_at_price: variant.compare_at_price * 100,
    })),
  };
}

export function convertRelewiseProduct(product) {
  const handle = product.data[`${window.Shopify.shop}_ShopifyHandle`].value;
  return {
    price: (product?.salesPrice || 0) * 100,
    compare_at_price: (product?.listPrice || 0) * 100,
    images: product.variant?.data[`${window.Shopify.shop}_ImageUrls`]?.value.$values || [],
    created_at: new Date(product.data[`${window.Shopify.shop}_CreatedAt`]?.value || 0),
    tags: product.data?.Tags?.value?.$values || [],
    vendor: product.data?.Vendor?.value || '',
    available: product.data?.IsAvailable?.value || false,
    title: product.displayName,
    name: product.displayName,
    id: product.data[`${window.Shopify.shop}_ShopifyProductId`]?.value,
    handle,
    url: `/products/${handle}`,
    variants: product.allVariants.map((variant) => ({
      ...variant,
      id: variant?.data?.[`${window.Shopify.shop}_ShopifyVariantId`]?.value,
      price: (variant?.salesPrice || 0) * 100,
      title: variant?.displayName || '',
      compare_at_price: (variant?.listPrice || 0) * 100,
      available: variant?.data?.IsAvailable?.value || false,
    })),
  };
}
